import { collectionsUrl } from '../../urls';

export const sortedWorksheetCollectionEmailsUrl = () => `${collectionsUrl()}/collection-emails`;

export const confirmCollectionsUrl = () => `${collectionsUrl()}/confirm-collections`;

export const submitWorksheetsToFinanceUrl = () =>
  `${collectionsUrl()}/submit-worksheets-to-finance`;
